import React from 'react'
import { useSelector } from 'react-redux'
import { Box, Button, ThemeProvider, Typography } from '@material-ui/core'
import { Carousel } from 'react-responsive-carousel'
import SlideShowItem from './SlideshowItem'
import SlideshowItemStyles from './SlideshowItemStyles'

function SlideshowScreen({ slideshowData, finalTheme, handleCloseSlideShow }) {
  const classes = SlideshowItemStyles({ finalTheme })
  console.log('[SlideshowScreen]: ', slideshowData)
  const errorData = useSelector((state) => state.slideshowScreen.error)
  const slideshowDataStatus = useSelector(
    (state) => state.slideshowScreen.status,
  )

  const [selectedItem, setSelectedItem] = React.useState(0)

  const mainTitle = slideshowData?.slideshowTitle || ''
  const articleId = slideshowData?.id || 0
  const slides = slideshowData?.slideshowPages ?? []
  const totalSlides = slides.length

  const handlePrev = () => {
    setSelectedItem((prev) => Math.max(prev - 1, 0))
  }

  const handleNext = () => {
    setSelectedItem((prev) => Math.min(prev + 1, totalSlides - 1))
  }

  function setSlideshowUnseen() {
    console.log('Slideshow Upadte called: ', articleId)
    handleCloseSlideShow(articleId)
  }

  const renderIndicator = (onClickHandler, isSelected, index, label) => {
    ;<li
      className="react-responsive-carousel__indicator"
      style={{ margin: '0 6px', display: 'inline-block' }}
      key={index}
    >
      <button
        type="button"
        aria-label={`${label} ${index + 1}`}
        onClick={onClickHandler}
        className={isSelected ? classes.indicatorActive : classes.indicator}
        style={{
          border: 'none',
          outline: 'none',
          padding: 0,
        }}
      />
    </li>
  }

  if (slideshowDataStatus === 'loading') {
    return (
      <Box className={classes.wrapper}>
        <Typography variant="body1">Loading slideshow...</Typography>
      </Box>
    )
  }

  if (errorData) {
    return (
      <Box className={classes.wrapper}>
        <Typography variant="body1" color="error">
          {errorData}
        </Typography>
      </Box>
    )
  }

  return (
    <ThemeProvider theme={finalTheme}>
      <Box className={classes.container}>
        <Box className={classes.header}>
          <Typography variant="h3" className={classes.headerText}>
            {mainTitle}
          </Typography>
        </Box>
        <Box className={classes.wrapper}>
          <Box style={{ width: '100%', maxWidth: 900 }}>
            <Carousel
              selectedItem={selectedItem}
              onChange={(index) => setSelectedItem(index)}
              showThumbs={false}
              showArrows={false}
              showStatus={false}
              showIndicators
              infiniteLoop={false}
              swipeable
              emulateTouch
              useKeyboardArrows
              transitionTime={600}
              renderIndicator={renderIndicator}
              swipeScrollTolerance={10}
            >
              {slides.map((content, index) => (
                <div key={`${content.title || 'slide'}-${index - 1}`}>
                  <SlideShowItem
                    img={content.imageURL}
                    title={content.title}
                    description={content.description}
                    carouselType="ForYou"
                  />
                </div>
              ))}
            </Carousel>
          </Box>
        </Box>
        <Box className={classes.footer}>
          <Box className={classes.controlsWrapper}>
            <Button
              type="button"
              onClick={handlePrev}
              disabled={selectedItem === 0}
              className={classes.navButton}
            >
              Previous
            </Button>

            <Box className={classes.indicatorsContainer}>
              {slides.map((_, index) => (
                <Box
                  key={`indicator${index + 0}`}
                  component="button"
                  type="button"
                  onClick={() => setSelectedItem(index)}
                  aria-label={`Go to slide ${index + 1}`}
                  className={
                    selectedItem === index
                      ? classes.indicatorActive
                      : classes.indicator
                  }
                  style={{
                    border: 'none',
                    outline: 'none',
                    padding: 0,
                  }}
                />
              ))}
            </Box>

            <Button
              type="button"
              onClick={
                selectedItem === totalSlides - 1
                  ? setSlideshowUnseen
                  : handleNext
              }
              // disabled={selectedItem === totalSlides - 1}
              className={
                selectedItem === totalSlides - 1
                  ? classes.navButtonClose
                  : classes.navButton
              }
            >
              {selectedItem === totalSlides - 1 ? 'Close' : 'Next'}
            </Button>
          </Box>
        </Box>
      </Box>
    </ThemeProvider>
  )
}

export default SlideshowScreen
